import { callApiWithAuthorization } from "../../../API/CallApi";


export async function getAllPortals(projectId) {
	try {
		const request = await callApiWithAuthorization(`/api/v0/nodes/${projectId}/Portal`);
		const response = await request.json();
		return [response, null];
	} catch (e) {
		return [null, e.message];
	}
}

export async function getPortalTargetPages(portalId) {
	try {
		const request = await callApiWithAuthorization(`/api/v0/portal/${portalId}/targetPages`);
		const response = await request.json();
		return [response, null];
	} catch (e) {
		return [null, e.message];
	}
}

export async function getMenuItem(menuItemId) {
	try {
		const request = await callApiWithAuthorization(`/api/v0/menuitem/${menuItemId}`);
		const response = await request.json();
		return [response, null];
	} catch (e) {
		return [null, e.message];
	}
}

export async function getEntitiesShownInMenuItems(portalId) {
	try {
        const request = await callApiWithAuthorization(
            `/api/v0/portal/${portalId}/entitiesInMenuItem`
        );
        const response = await request.json();
        return [response, null];
    } catch (e) {
        return [null, e.message];
    }
}